import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export const updateReferralStatus = async (userId, status) => {
  try {
    const response = await apiFetch(`${API_BASE}/admin/referral/${userId}`, {
      method: 'PUT',
      body: JSON.stringify({ referralAmountClaimStatus: status })
    });
    return await response.json();
  } catch (_error) {
    return { success: false, message: 'Failed to update referral status.' };
  }
};
